// removed by extract-text-webpack-plugin
module.exports = {"ListItem":"_3gvB7YWPqEeI6t41HCdhT","PopupHeader":"-fmm4_stFyAkR9jH3USpQ","PopupBody":"P5NG70BYgqv60FlhE3u9y","ItemTitle":"_1pvD50-3pcJI_AtgniWlr1","ItemBody":"_1ks980-hr2xkda5H--Zlf9","FAQItemButton":"_2-GhkN1JZbND7pJX8UbpBU","ConfirmRemoval":"_2lIov10JfBhGQIc3Zuz-_8","ConfirmRemovalPopup":"_1TZtwiId3ewi50y8cEphKT","FAQAdd":"_1LBpqzeApZLZW6Iap10VJc","Blur":"_3Zsa95IqqEp0fs55oSyYTf","FAQItemQuestionTextArea":"_2lcpY4-gVLwrrCj1Pr2nRq","SVGButton":"_1N3uLCsa11XrMiUumVvpMY"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Normal/ListItem/style.css
// module id = 816
// module chunks = 0